import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';

type UploadProcess =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'success' }
  | { status: 'error'; code: 'incompatible_file' | 'not_an_image' | 'save_failed' };

type State = {
  inputFile: {
    uploadProcess: UploadProcess;
  };
  outputFile: {
    uploadProcess: UploadProcess;
  };
};

type Actions = {
  inputFileActions: {
    setUploadProcess(value: UploadProcess): void;
  };
  outputFileActions: {
    setUploadProcess(value: UploadProcess): void;
  };
  reset(): void;
};

const INITIAL_STATE: State = {
  inputFile: {
    uploadProcess: {
      status: 'idle',
    },
  },
  outputFile: {
    uploadProcess: {
      status: 'idle',
    },
  },
};

export const useStore = create<State & Actions>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      inputFileActions: {
        setUploadProcess(value) {
          set(
            (state): State => ({
              ...state,
              inputFile: {
                ...state.inputFile,
                uploadProcess: value,
              },
            }),
            undefined,
            {
              type: 'inputFileActions/uploadProcess/set',
            },
          );
        },
      },

      outputFileActions: {
        setUploadProcess(value) {
          set(
            (state): State => ({
              ...state,
              outputFile: {
                ...state.outputFile,
                uploadProcess: value,
              },
            }),
            undefined,
            {
              type: 'outputFileActions/uploadProcess/set',
            },
          );
        },
      },

      reset() {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),
    { store: 'pointCloudUIStore', ...DEVTOOLS_OPTIONS },
  ),
);
